import _ from "lodash";
import { ItalicFontStyle, RegularFontStyle, weightMap } from "@superwall-me/schema";
export const getVariantOptions = (fontFace)=>{
    if (!fontFace || fontFace.variants.length <= 0) return [];
    const variants = fontFace.variants;
    const weights = variants.map((variant)=>{
        const digits = variant.match(/\d+/g);
        return digits ? digits[0] : "400";
    });
    console.log("!! weights", weights);
    const options = _.uniq(weights).sort().map((weight)=>{
        return {
            label: weightMap[weight] || "Normal",
            value: weight,
            styles: variants.filter((variant)=>// weight != RegularFontStyle
                //   ? variant.includes(weight)
                //   : !variant.match(/\d+/g) || variant.includes("400")
                variant.includes(weight)).map((variant)=>{
                return {
                    icon: variant.includes(ItalicFontStyle) ? ItalicFontStyle : "italic-not",
                    value: variant,
                    url: fontFace.files[variant]
                };
            })
        };
    });
    // if options includes normal, move it to the front
    const normal = options.find((option)=>option.value === "400");
    if (normal) {
        options.splice(options.indexOf(normal), 1);
        options.unshift(normal);
    }
    return options;
};
export const getLabelFromVariants = (variants)=>{
    let weights = _.uniq(variants.map((variant)=>{
        const digits = variant.match(/\d+/g);
        return digits ? digits[0] : "Normal";
    })).filter((e)=>e.trim() !== "");
    const numerics = weights.map((weight)=>parseInt(weight)).filter((e)=>e).map((e)=>e.toString());
    const nonNumerics = weights.filter((weight)=>isNaN(parseInt(weight)));
    const range = numerics.length > 1 ? `${weightMap[numerics[0]]} - ${weightMap[numerics[numerics.length - 1]]}` : "Regular";
    const italic = variants.some((variant)=>variant.includes(ItalicFontStyle)) ? [
        "Italic"
    ] : [];
    weights = _.uniq([
        ...italic,
        ...[
            range
        ]
    ]).filter((e)=>e.trim() !== "");
    return weights.join(", ");
};
export const getStyleFromVariant = (variant)=>{
    const digits = variant.match(/\d+/g);
    const style = variant.includes(ItalicFontStyle) ? ItalicFontStyle : RegularFontStyle;
    const weight = digits ? digits[0] : "400";
    return {
        weight,
        style
    };
};
